import type { Trigger } from './types';

export const onPageLoadTrigger: Trigger = (triggerName) => (activate) => {
  const activateWithTimeout = () =>
    setTimeout(() => activate(triggerName), 300);

  document.readyState === 'complete'
    ? activateWithTimeout()
    : window.addEventListener('load', activateWithTimeout);
};
